import Datagent from "datagent";
import Schema from "datagent/src/classes/Schema.class";
import {respondData,requestHandle} from "../utils";
import Fecha from "@/utils/type/Fecha"

const {filter, format, getField, awaitTo} = Datagent.Hooks;

import {defaults} from "datagent/src/utils";

// export const newTaskSchame = new Schema({
//   'userInCharge'           : {type: String, default:''}, //业务员
//   'sceneType'              : {type: Number, default: ''}, // 应用场景 1-榜单（报告）；2-榜单（舆情）；3-上市公司舆情
//   'industryId'               : {type: Number, default: ''}, //行业
//   'plannedCompletionTime'  : {type: val=>Fecha(val, "YYYY-MM-DD"), default: ''}, // 目标完成时间
// })

const name = "taskPool/task";
const Model = Datagent.Model({
    name,
    fields: {
        'id'                     : {type: Number, default: null},
        'userInCharge'           : {type: String, default:''}, //业务员
        'sceneType'              : {type: Number, default: ''}, // 应用场景 1-榜单（报告）；2-榜单（舆情）；3-上市公司舆情
        'industry'               : {type: String, default: ''}, //行业
        'plannedCompletionTime'  : {type: val=>Fecha(val, "YYYY-MM-DD"), default: ''}, // 目标完成时间
        'timeScope'              : {type: String, default: ''}, // 数据时间范围
        'isCompleted'            : {type: Number, default: ''}, // 完成标记：0-待完成；1-已完成
        'completeRate'           : {type: String, default: ''}, // 完成率
        'auditRate'              : {type: String, default: ''}, // 审核率
        'isAudited'              : {type: Number, default: ''}, //完成标记：0-待审核；1-审核中；2-已审核
        'acceptStatus'           : {type: Number, default: ''}, // 认领情况：0-待接受；1-已接受
        'auditDetail'            : {type:String, default: ''} //审核备注
    },
    methods: {
        completion(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`taskPool/completion`,params)
        },
        accept(params, opts){
          const { origin } = defaults(opts);
          if(typeof params.id === 'undefined') throw Error('必须有id')
          if(typeof params.acceptStatus === 'undefined') throw Error('必须有acceptStatus')
          return this.remote(origin).put(`taskPool/task/accept`, params)
        },
        users(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).get(`common/user/`, params)
        },
        destroy(params, opts){
          const { origin } = defaults(opts);
          const { id } = params
          if(typeof params.id === 'undefined') throw Error('必须有id')
          return this.remote(origin).delete(`${this._url}/${id}`, params)
        }
    },
    hooks: {
        ...Datagent.mapSendHook([format()]),
        fetch: { after: [respondData(), requestHandle(), getField("data", format())] },
        completion: { after: [respondData(), requestHandle(), getField("data", format())] },
        find: { after: [respondData(), requestHandle(), format()] },
        accept: { after: [respondData(), requestHandle()] },
        users: { after: [respondData(), requestHandle()] },
    }
});

Model.ModelName   = name;
export default Model;
